import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionItemPimResourcesConverter extends CmsConverterService<AccordionItemPimResourcesData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const ACCORDION_ITEM_PIM_RESOURCES_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionItemPimResourcesData>>('AccordionItemPimResourcesConverter')

export type AccordionItemPimResourcesData = ConvertedComponentData
